<template>
  <f7-page>
    <!-- PRELOADER VISUAL NO BLOQUEANTE -->
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div v-if="loaded">
      <div class="custom-table-container tableContainer">
        <ComplaintManagement
          :store="customStore"
          :initial-status="initialDashboardStatus"
        />
      </div>
    </div>
  </f7-page>
</template>

<script>
import ComplaintManagement from '@/components/ComplaintManagement/index.vue';
// import GoRegisterComplaint from '@/components/UtilityComponents/GoRegisterComplaint/index.vue';
// import ComplaintDetailsPopUp from '@/components/ComplaintManagement/ComplaintDetails/ComplaintDetailsPopUp/index.vue';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  components: {
    ComplaintManagement,
    // GoRegisterComplaint,
    // ComplaintDetailsPopUp,
  },
  data() {
    return {
      loaded: false,
      customStore: [],
    };
  },
  computed: {
    initialDashboardStatus() {
      const status = this.$f7route?.query?.estado || '';
      const allowedStatuses = [
        'pending_action',
        'in_progress',
        'resolved',
      ];

      return allowedStatuses.includes(status) ? status : '';
    },
    ...mapState('complaintManagement', ['complaints']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('complaintList'),
        disabled: false,
        page: 'ComplaintManagement',
        active: true,
      },
    ]);
  },
  async mounted() {
    try {
      // this.$f7.preloader.show();

      this.loaded = false;

      // Mapa (exacto) ES -> key en TranslatedComplaintsOrigins
      const ORIGIN_MAP = {
        'Resultados de Ensayo': 'TestResults',
        'Petición del Cliente': 'CustomerRequest',
        'Tiempos de Respuesta': 'ResponseTimes',
        Oferta: 'Quote',
        'Error Ingreso Muestra': 'SampleEntryError',
        'Informe Incorrecto': 'IncorrectReport',
        'Opinión sobre la Atención': 'CustomerServiceFeedback',
      };
      // Mapa (exacto) ES -> key en TranslatedComplaintsColors
      const COLOR_MAP = {
        red: 'pendingManagement',
        yellow: 'inManagement',
        green: 'resolved',
      };

      await this.fetchComplaintList();

      const list = Array.isArray(this.complaints)
        ? this.complaints
        : [];

      this.customStore = list.map((c) => {
        // Fecha dd/mm/yyyy -> Date
        const [day, month, year] = String(c.created || '')
          .split('/')
          .map(Number);
        const createdDate =
          year && month && day
            ? new Date(year, month - 1, day)
            : null;

        // Resuelve la key y traduce (con fallback si no hay mapeo)
        const originKey = ORIGIN_MAP[c.origen];
        const translatedOrigin = originKey
          ? this.$t(`TranslatedComplaintsOrigins.${originKey}`)
          : c.origen;

        const statusKey = COLOR_MAP[c.color];
        const translatedColorStatus = statusKey
          ? this.$t(`${statusKey}`)
          : c.color;
        return {
          ...c,
          created: createdDate,
          translatedOrigin,
          translatedColorStatus,
        };
      });
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error.message)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      // this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('complaintManagement', ['fetchComplaintList']),
  },
};
</script>
<!-- <style lang="scss">
@import './paramsTable.styles.scss';
</style> -->
